export default class User {
    constructor(){
        this.id = null;
        this.fullname = null;
        this.contact = {
            'phone' : null,
            'email' : null,
        };
        this.address = {
            city : null,
            postalCode : null,
            street : null
        };
    }
}